// Internal paths (starting with /) get the language prefix; full URLs and # are used as they are
export const localizeHref = (lng: string, href: string) => (href.startsWith('/') ? `/${lng}${href}` : href)
